<h2 mat-dialog-title>
  Indstillinger
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <div>
    <form [formGroup]="form">
      <p>Opsætning af indstillinger, fx om privatpersoner skal fremgå med navn eller blot som "privatperson" i printet.</p>
      <div fxLayout="row" fxFlexAlign="space-between">
        <div fxFlex="50">
          <div class="mb-2">
            <div>
              <label id="attachment_scale_label">Skalering af bilag ({{formatAttachmentScale}})</label>
            </div>
            <mat-slider min="0.1" max="1" step="0.05"  formControlName="attachment_scale" ngDefaultControl>
              <input matSliderThumb>
            </mat-slider>
          </div>
          <div>
            <mat-checkbox ngDefaultControl formControlName="show_private_name">Vis navn på privatpersoner</mat-checkbox>
          </div>
          <div>
            <mat-checkbox ngDefaultControl formControlName="show_private_address">Vis adresse på privatpersoner</mat-checkbox>
          </div>
          <div>
            <mat-checkbox ngDefaultControl formControlName="warning_multiple_applications">Vis advarsel ved flere, ubehandlere ansøgninger fra samme ansøger.</mat-checkbox>
          </div>
          <div>
            <mat-checkbox ngDefaultControl formControlName="exceeding_grant_warning">Vis advarsel om <b>Indstillet beløb</b> højere end <b>Ansøgt beløb.</b></mat-checkbox>
          </div>
        </div>
        <div fxFlex="50">
          <div class="mb-2">
            <label id="compact_history">Historik-nøgle</label>
            <mat-radio-group ngDefaultControl formControlName="compact_history" aria-labelledby="compact_history" class="vertical-radio-group">
              <mat-radio-button value="digest">Standard (digest)</mat-radio-button>
              <mat-radio-button value="company_registration_no">CVR-nummer</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="mb-2">
            <mat-checkbox ngDefaultControl formControlName="hide_priority">Skjul prioritet (rækkefølge)</mat-checkbox>
          </div>
        </div>
      </div>
    </form>
    <div fxFlex class="mt-3 pt-3">
      <div>
        <label id="sub_prioritoies_label">Angiv antallet af underpositioner</label>
      </div>
      <mat-form-field>
        <mat-label>
          Antal af underpositioner
        </mat-label>
        <input type="number" (blur)="setPriorityValues()" [(ngModel)]="subPriorityAmount" matInput [disabled]="hide_priority.value">
        <mat-hint>Værdien 3 angiver værdierne: [1.0, 1.1, 1.2, 1.3, 2.0, 2.1, 2.2, 2.3]</mat-hint>
        @if (priorities.hasError('required')) {
          <mat-error><strong>Skal</strong> udfyldes.</mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <!-- Individual print layouts -->
  <div [formGroup]="form.controls.individual_print">
    <mat-divider class="my-3"></mat-divider>
    <div fxLayout="row" class="mb-3">
      <label>Individuel print</label>
    </div>

    <div fxLayout="row" class="mb-2">
      <label>Header</label>
    </div>
    <div fxLayout="row" fxLayoutGap="20px">
      @for (group of individualPrintLayout.meta; track group) {
        <div fxLayout="column">
          @for (entry of group; track entry) {
            @if ('control' in entry) {
              <mat-checkbox color="primary" [formControlName]="entry.control">
                <span>{{entry.label}}</span>
              </mat-checkbox>
            } @else {
              <mat-checkbox color="primary" [checked]="!!entry.checked" (change)="toggleMeta($event, entry.key)">
                <span>{{entry.label}}</span>
              </mat-checkbox>
            }
          }
        </div>
      }
    </div>

    <div fxLayout="row" class="my-2">
      <label>Indhold på sagsfremstilling</label>
    </div>
    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column">
        <mat-checkbox color="primary" formControlName="description">
          <span>Ansøgers korte beskrivelse</span>
        </mat-checkbox>
        <mat-checkbox color="primary" formControlName="spiderweb">
          <span>Vurdering(spiderweb)</span>
        </mat-checkbox>
      </div>
      <div fxLayout="column">
        <mat-checkbox color="primary" [formControl]="showHistory">
          <span>Ansøger historik</span>
        </mat-checkbox>
        @if (showHistory.value) {
          <div>
            <mat-radio-group formControlName="history" fxLayout="column" class="ml-3">
              <mat-radio-button value="compact" color="primary">
                <span>Kompakt historik (to + sum)</span>
              </mat-radio-button>
              <mat-radio-button value="standard" color="primary">
                <span>Total historik (alt)</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Style configurations -->
  <div>
    <mat-divider class="my-3"></mat-divider>
    <div fxLayout="row" class="mb-2">
      <label>Print layout konfiguration</label>
    </div>

    <div [formGroup]="form">
      <mat-radio-group formControlName="style" aria-labelledby="style" class="vertical-radio-group" ngDefaultControl>
        <mat-radio-button value="standard">Standard</mat-radio-button>
        <mat-radio-button value="ap">A.P. Møller Fondene</mat-radio-button>
      </mat-radio-group>
    </div>

    @if (form.controls.style.value === 'standard') {
      @let formStyleConfig = form.controls.styleConfig;
      <ng-container [formGroup]="formStyleConfig">
        <div fxLayout="row" fxFlexAlign="space-between" fxLayoutGap="1em">
          <div fxFlex="50" fxLayout="column">
            <label class="style-config-label">Font</label>
            <mat-form-field>
              <mat-label>Font</mat-label>
              <mat-select formControlName="font">
                @for (value of fonts; track value) {
                  <mat-option [value]="value">{{value}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxLayout="column">
            <label class="style-config-label">Logo</label>
            <ng-container formGroupName="logo">
              <mat-form-field>
                <mat-label>Bredde</mat-label>
                <input type="number" matInput formControlName="width">
                <span matSuffix class="mr-3">mm</span>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Position</mat-label>
                <mat-select formControlName="position">
                  @for (entry of horizontalAlignments | keyvalue; track entry.key) {
                    <mat-option [value]="entry.key">{{entry.value}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>
        </div>

        <div fxLayout="row" fxFlexAlign="space-between" fxLayoutGap="1em">
          <div fxFlex="50" fxLayout="column" formGroupName="font_sizes">
            <label class="style-config-label">Font størrelser</label>
            @for (entry of fontSizes | keyvalue; track entry.key) {
              <mat-form-field>
                <mat-label>{{entry.value.label || entry.key}}</mat-label>
                <input type="number" matInput [formControlName]="entry.key" [placeholder]="'Standard værdi ' + entry.value.value">
                <span matSuffix class="mr-3">pt</span>
              </mat-form-field>
            }
          </div>
          <div fxFlex="50" fxLayout="column" formGroupName="footer">
            <mat-checkbox [formControl]="hasFooter">Sidefod tekst</mat-checkbox>
            @if (hasFooter.value) {
              <mat-form-field>
                <mat-label>Tekst</mat-label>
                <input matInput formControlName="text">
              </mat-form-field>
              @let footerOptions = formStyleConfig.controls.footer.controls.options;
              <ng-container formGroupName="options">
                <mat-form-field>
                  <mat-label>Tekstjustering</mat-label>
                  <mat-select formControlName="align">
                    @for (entry of horizontalAlignments | keyvalue; track entry.key) {
                      <mat-option [value]="entry.key">{{entry.value}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Font størrelse</mat-label>
                  <input type="number" matInput formControlName="size">
                  <span matSuffix class="mr-3">pt</span>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Linjeafstand</mat-label>
                  <input type="number" matInput formControlName="leading">
                  <span matSuffix class="mr-3">pt</span>
                </mat-form-field>
                <mat-form-field>
                  @let color = footerOptions.controls.color;
                  <mat-label>Farve</mat-label>
                  <input matInput formControlName="color">
                  <mat-icon matSuffix (click)="openPicker()" [style]="{ color: '#' + color.value }">palette</mat-icon>
                  @if (footerOptions.controls.color.hasError('color')) {
                    <mat-error>Ugyldig farve</mat-error>
                  }
                </mat-form-field>
                <div [colorPicker]="'#' + color.value"
                     (colorPickerChange)="setFooterColor($event)"
                     cpPosition="bottom"
                     cpOutputFormat="hex"
                ></div>
                <mat-form-field>
                  <mat-label>Tegnafstand</mat-label>
                  <input type="number" matInput formControlName="character_spacing">
                  <span matSuffix class="mr-3">pt</span>
                </mat-form-field>
              </ng-container>
            }
          </div>
        </div>
      </ng-container>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
</mat-dialog-actions>
